import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useSearchParams } from "react-router-dom";
import { PageHeader } from "@/components/common/States";
import { useAuth } from "@/context/AuthContext";
import PrimReport from "@/components/prim/PrimReport";
import PrimAccounts from "@/components/prim/PrimAccounts";
import Performance from "@/components/prim/Performance";
import MyPrim from "@/components/prim/MyPrim";
import PrimSettings from "@/components/prim/PrimSettings";

export default function Prim() {
  const { can, flag } = useAuth();
  const [params, setParams] = useSearchParams();
  const bonus = flag("bonus_view");
  const manage = can("prim", "approve") && bonus;
  const tabs = [
    bonus && ["report", "Prim Raporu", <PrimReport key="r" initialPeriod={params.get("period")} />],
    bonus && ["accounts", "Prim Hesabı & Ödemeler", <PrimAccounts key="a" />],
    ["performance", "Personel Performansı", <Performance key="p" />],
    ["me", "Benim Performansım", <MyPrim key="m" />],
    manage && ["settings", "Prim Ayarları", <PrimSettings key="s" />],
  ].filter(Boolean);
  const tab = params.get("tab") || tabs[0][0];
  return (
    <div data-testid="prim-page">
      <PageHeader title="Prim & Performans" subtitle="Satış personeli primleri, onay akışı, prim hesabı ve performans" testid="prim-title" />
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList className="mb-4">{tabs.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`prim-tab-${k}`}>{l}</TabsTrigger>)}</TabsList>
        {tabs.map(([k, , el]) => <TabsContent key={k} value={k}>{el}</TabsContent>)}
      </Tabs>
    </div>
  );
}
